// src/context/site/siteErrorCopy.js — OUR sentence for a refused Site Manager request (v201).
// ⛔ Never the server's message. The rule (FE copy for a known code → "admin only" for a plain 403 → the 5xx
// reference → network → a generic sentence printing the code) lives in context/contextErrorCopy.js; this keeps
// the Site Manager's own three sentences. The two contract exceptions (CONTEXT_URL_DELTA_REFUSED,
// CONTEXT_EXCLUDE_FILE_INVALID — their message names the offending URL / file) and the 402 family
// (RunRefusalNotice) are handled by the caller before this is asked.
import { contextErrorCopy } from '../contextErrorCopy.js';

const SITE_KEYS = {
  server: 'fallback.server',
  network: 'fallback.network',
  generic: 'site.modal.errors.generic',
};

export function siteErrorCopy(t, err) {
  return contextErrorCopy(t, err, SITE_KEYS);
}
